import { authorizedRequestJson } from '../lib/authSession';

export function listOrders({ token }) {
  return authorizedRequestJson('/orders');
}

export function quoteOrder({ token, order }) {
  return authorizedRequestJson('/orders/quote', {
    method: 'POST',
    body: order,
  });
}

export function createOrder({ token, order }) {
  return authorizedRequestJson('/orders', {
    method: 'POST',
    body: order,
  });
}

export function updateOrderStatus({ token, orderId, status }) {
  return authorizedRequestJson(`/orders/${encodeURIComponent(orderId)}/status`, {
    method: 'PATCH',
    body: { status },
  });
}
